import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/app/App';
import { registerServiceWorker } from './ui/app/swRegistration';
import { preloadGoogle } from './platform/googleAuth';
import './ui/styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root 없음');

registerServiceWorker();
preloadGoogle();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
